import { Icon } from '@chakra-ui/react';
import { FiMessageCircle } from 'react-icons/fi';

const CommentIcon = (props) => {
  return (
    <Icon as={FiMessageCircle} {...props} />
  );
}

export default CommentIcon;